import type {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from 'react-query';
import { useQuery } from 'react-query';

import type { Freelancer } from '../types';

type UseFreelancerDetailsHandler = {
  data: Freelancer;
  error: string | null;
  isLoading: boolean;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => Promise<QueryObserverResult<Freelancer, string>>;
};

const useFreelancerDetails = (
  freelancerId?: number,
  jobId?: number,
): UseFreelancerDetailsHandler => {
  const { isLoading, error, data, refetch } = useQuery<
    UseFreelancerDetailsHandler,
    string,
    Freelancer
  >(['freelancer-details', freelancerId], async () => {
    if (!freelancerId) return {};
    const response = await fetch(
      `/api/organisation/freelancers/${freelancerId}/${jobId}/details/`,
    );
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  });
  return { data: data ?? ({} as Freelancer), error, isLoading, refetch };
};

export default useFreelancerDetails;
